import axios from "./axios";

export async function fetchPayslips(params = {}) {
  return axios.get("/payslips", { params });
}

export async function downloadPayslipPdf(id) {
  return axios.get(`/payslips/${id}/pdf`, { responseType: "blob" });
}

export async function queuePayslipSync(payload = {}) {
  return axios.post("/tripletex/payslips/sync", payload);
}
